import React, { useEffect } from 'react'
import Login from '../../../components/organism/login/index.tsx'
import { useAppDispatch } from '../../../store/index.ts'
import { getUserDataFromStorage, removeUserDataFromstorage } from '../../../helpers/localStorageHelper.ts'
import { setUserData } from '../../../store/userSlice.ts'
import { useNavigate } from 'react-router-dom'
import { fetchUserData } from '../../../endpoint/index.ts'

const Admin : React.FC = () => {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	// No anonymous sign-in here: loginUser (called from <Login/>) needs no
	// prior auth session, and getUserData below requires a real (self or
	// super-admin) identity that an anonymous session could never satisfy.
	// An anonymous sign-in racing signInWithCustomToken (endpoint/index.ts)
	// could otherwise overwrite an admin's real session back to anonymous.
	useEffect(() => {
		getUserData()
	}, [])

	const getUserData = async () => {
		try {
			const userFromStorage = getUserDataFromStorage()
			const refreshedUser = await fetchUserData({ userId: userFromStorage!.id })

			if (refreshedUser) {
				if (refreshedUser.isActive) {
					dispatch(setUserData(refreshedUser))
					navigate('/admin/dashboard')
				}
			} else {
				removeUserDataFromstorage()
				navigate('/admin')
			}
		} catch (e) {
			console.log(e)
			removeUserDataFromstorage()
			navigate('/admin')
		}
	}

	return (
		<div>
			<Login />
		</div>
	)
}

export default Admin
